module.exports = __webpack_public_path__ + "img/Pattern04.cfcf8ca0.png";